import { render } from "./create-social-post.vue?vue&type=template&id=6e72b228&ts=true"
import script from "./create-social-post.vue?vue&type=script&lang=ts"
export * from "./create-social-post.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__